import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import {
  TextField,
  Button,
  Autocomplete,
  Switch,
  Select,
  MenuItem
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { showErrorMessage } from "../redux/appSlice";
import { useDispatch } from "react-redux";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";
import DateField from "../components/DateField";
import ImageUploadField from "../components/ImageUploadField";
import QuantityStepper from "../components/QuantityStepper";
import dayjs from "dayjs";
import { MdClear } from "react-icons/md";

export const Banner = () => {
  const defaultDate = dayjs(new Date().toString());
  const [banners, setBanners] = useState([]);
  const [anunciantes, setAnunciantes] = useState([]);
  const [agregando, setAgregando] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [link, setLink] = useState("");
  const [anuncianteText, setAnuncianteText] = useState("");
  const [anuncianteSeleccionado, setAnuncianteSeleccionado] = useState({});
  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(0);
  const [imagen, setImagen] = useState();
  const [imagenModal, setImagenModal] = useState();
  const [imgPreviewSrc, setImgPreviewSrc] = useState("");
  const [imgModalPreviewSrc, setImgModalPreviewSrc] = useState("");
  const [activo, setActivo] = useState(false);
  const [incluirInactivos, setIncluirInactivos] = useState(false);
  const [tipoBanner, setTipoBanner] = useState(1);
  const sendRequest = useRequestHandler();
  const [fechaDesde, setFechaDesde] = useState(defaultDate);
  const [fechaHasta, setFechaHasta] = useState();

  const refrescarGrilla = () => {
    sendRequest(Servicios.ObtenerBanners, [incluirInactivos], data => {
      setBanners(data?.data);
    });
  };
  const dispatch = useDispatch();

  const limpiarForm = () => {
    setDescripcion("");
    setImagen(null);
    setImagenModal(null);
    setImgPreviewSrc("");
    setImgModalPreviewSrc("");
  };

  useEffect(() => {
    refrescarGrilla();
    obtenerAnunciantes();
  }, [incluirInactivos]);

  const obtenerAnunciantes = () => {
    sendRequest(Servicios.ObtenerAnunciantes, [], data => {
      setAnunciantes(data?.data);
    });
  };

  const eliminarBanner = id => {
    sendRequest(Servicios.EliminarBanner, [id], refrescarGrilla);
  };

  const handleTipoBannerChange = event => {
    setTipoBanner(event.target.value);
  };

  const columns = [
    { field: "id", headerName: "ID" },
    { field: "anuncianteNombre", headerName: "Anunciante" },
    { field: "tipoBannerId", headerName: "Tipo" },
    {
      field: "link",
      headerName: "Link",
      flex: 50,
      renderCell: params => {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${params?.row?.link}`}
          >
            {params?.row?.link}
          </a>
        );
      }
    },
    { field: "peso", headerName: "Peso" },
    {
      field: "imagenPath",
      headerName: "Imagen",
      flex: 50,
      renderCell: params => {
        return (
          <img
            style={{ width: "250px", height: "60px" }}
            src={params?.row?.imagenPath}
          ></img>
        );
      }
    },
    {
      field: "actionEdit",
      headerName: "",
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setIdEditando(params.row.id);
          setDescripcion(params.row.descripcion);
          setIntercalado(params.row.peso);
          setLink(params.row.link);
          let anuncianteTmp = anunciantes.filter(
            x => x.id == params.row.anuncianteId
          )?.[0];
          setActivo(params.row.activo);
          setAnuncianteSeleccionado(anuncianteTmp);
          setAnuncianteText(anuncianteTmp?.nombre);
          setImgPreviewSrc(params.row.imagenPath);
          setImgModalPreviewSrc(params.row.modalImagenPath);
          setTipoBanner(params.row.tipoBannerId);
          setFechaDesde(dayjs(params.row.fechaDesde));
          setFechaHasta(
            params.row.fechaHasta ? dayjs(params.row.fechaHasta) : null
          );
        };

        return <EditIcon className="action-icon" onClick={onClick} />;
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      renderCell: params => {
        const onClick = e => {
          if (window.confirm("¿Confirmás eliminar el Banner?")) {
            eliminarBanner(params?.row?.id);
          }
        };

        return <DeleteIcon className="action-icon" onClick={onClick} />;
      }
    }
  ];

  const handleGuardar = () => {
    if (editando) {
      sendRequest(
        Servicios.ModificarBanner,
        [
          {
            id: idEditando,
            anuncianteId: anuncianteSeleccionado.id,
            descripcion: descripcion,
            link: link,
            peso: intercalado,
            activo: activo,
            tipoBannerId: tipoBanner,
            fechaDesde,
            fechaHasta
          },
          imagen,
          imagenModal
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    } else {
      sendRequest(
        Servicios.CrearBanner,
        [
          {
            anuncianteId: anuncianteSeleccionado.id,
            descripcion: descripcion,
            link: link,
            peso: intercalado,
            activo: activo,
            tipoBannerId: tipoBanner,
            fechaDesde,
            fechaHasta
          },
          imagen,
          imagenModal
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    }
  };

  const [intercalado, setIntercalado] = useState(3);

  return (
    <>
      <>
        {!agregando ? (
          <div className="card-modern">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
              <div className="page-header">
                <h4 className="page-title">Banner publicitarios</h4>
              </div>
              <div className="flex items-center gap-2">
                <Switch
                  checked={incluirInactivos}
                  onChange={e => setIncluirInactivos(!incluirInactivos)}
                  inputProps={{ "aria-label": "controlled" }}
                />
                Incluir inactivos
              </div>
              <div>
                <Button
                  variant={"contained"}
                  onClick={() => {
                    setAgregando(true);

                    setIdEditando(0);
                    setDescripcion("");
                    setIntercalado(4);
                    setLink("");
                    setActivo(true);
                    setAnuncianteSeleccionado({});
                    setAnuncianteText("");
                    setImgPreviewSrc("");
                    setImgModalPreviewSrc("");
                  }}
                >
                  Agregar
                </Button>
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="grid-wrapper w-full">
              {banners?.length > 0 ? (
                <DataGrid
                  rows={banners}
                  columns={columns}
                  checkboxSelection={false}
                />
              ) : (
                <h5>No se encontraron resultados</h5>
              )}
            </div>
          </div>
        ) : (
          <div className="card-modern">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="page-header">
                  <h4 className="page-title">
                    {editando ? "Modificar Banner" : "Nuevo Banner"}
                  </h4>
                </div>
                <div className="mb-3">
                  <Autocomplete
                    disabled={editando}
                    defaultValue={anuncianteSeleccionado?.nombre}
                    onChange={(event, newValue) => {
                      setAnuncianteSeleccionado(newValue);
                    }}
                    options={anunciantes}
                    getOptionLabel={option =>
                      option.nombre ?? anuncianteSeleccionado?.nombre
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        value={anuncianteText}
                        onChange={e => setAnuncianteText(e.target.value)}
                        label="Seleccionar anunciante"
                        variant="outlined"
                      />
                    )}
                  />
                </div>
                <div className="mb-3">
                  <Select value={tipoBanner} onChange={handleTipoBannerChange}>
                    <MenuItem value={1}>Tipo 1 - Rectangular tablados</MenuItem>
                    <MenuItem value={2}>Tipo 2 - Cuadrado tablados</MenuItem>
                    <MenuItem value={3}>
                      Tipo 3 - Rectangular detalle tablado
                    </MenuItem>
                  </Select>
                </div>
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Descripción del banner"
                    value={descripcion}
                    onChange={e => setDescripcion(e.target.value)}
                  />
                </div>
                <div className="mb-3 mt-3">
                  <QuantityStepper
                    label="Intercalado"
                    value={intercalado}
                    onChange={setIntercalado}
                    min={1}
                    max={3}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Link"
                    value={link}
                    onChange={e => setLink(e.target.value)}
                  />
                </div>
                <div className="mb-3 flex items-center gap-2">
                  <Switch
                    label="Activo"
                    checked={activo}
                    onChange={e => setActivo(!activo)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  Activo
                </div>
                <div className="mb-3">
                  <DateField
                    label="Desde"
                    value={fechaDesde}
                    onChange={setFechaDesde}
                  />
                </div>
                <div className="mb-3 flex items-center gap-2">
                  <DateField
                    label="Hasta"
                    value={fechaHasta}
                    onChange={setFechaHasta}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => setFechaHasta(null)}
                  >
                    <MdClear />
                  </Button>
                </div>
              </div>
              <div className="flex-1 flex flex-col gap-4">
                <ImageUploadField
                  value={imagen}
                  previewSrc={imgPreviewSrc}
                  onChange={(file, previewDataUrl) => {
                    setImagen(file);
                    setImgPreviewSrc(previewDataUrl);
                  }}
                  onError={message => dispatch(showErrorMessage(message))}
                  label="Cargar banner"
                  inputId="upload-photo-banner"
                />
                <ImageUploadField
                  value={imagenModal}
                  previewSrc={imgModalPreviewSrc}
                  onChange={(file, previewDataUrl) => {
                    setImagenModal(file);
                    setImgModalPreviewSrc(previewDataUrl);
                  }}
                  onError={message => dispatch(showErrorMessage(message))}
                  label="Cargar modal"
                  inputId="upload-photo-modal"
                />
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex justify-between w-full">
              <div className="text-start">
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    limpiarForm();
                    setEditando(false);
                    setAgregando(false);
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div className="text-end">
                <Button variant={"contained"} onClick={handleGuardar}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default withAuthenticationRequired(Banner, {
  onRedirecting: () => <Loading />
});
